import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { GlobalService } from 'projects/common-repo/src/app/core/services/global.service';
import { AppEvents } from '../../../../../../common-repo/src/app/core/utils/app-events';

@Component({
  standalone:true,
  selector: 'app-experience-people-tab',
  templateUrl: './experience-people-tab.component.html',
  styleUrls: ['./experience-people-tab.component.scss'],
  imports:[DependenciesModule]
})
export class ExperiencePeopleTabComponent implements OnInit {
  public universalService:any;
  public router:any;
  cleverTapEventsService:any;
  @Input() showExperienceNow:boolean = false;

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showExperienceNow) {
      this.closePopUp();
    }else if (event.key === "Enter" && this.showExperienceNow){
      this.experienceNow();
    }
  }

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(globalService);
  }

  ngOnInit(): void {
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc()
  }

  closePopUp(){
    this.showExperienceNow = false;
    AppEvents.globalObservable.next({showEnablePeopleTabPopUp: false});
  }


  experienceNow(){
    this.closePopUp();
    this.cleverTapEventsService.FacesListViewed('Consent_Thankyou');
    this.router.navigate(['people']);
  }
}
